var map = {
	"./build": 3847,
	"./build.json": 3847,
	"./build.png": 1985,
	"./entity": 6160,
	"./entity.json": 6160,
	"./entity.png": 8117,
	"./map-piece-manifest": 7639,
	"./map-piece-manifest.json": 7639,
	"./map-sprite-manifest": 4270,
	"./map-sprite-manifest.json": 4270,
	"./monster": 8417,
	"./monster.json": 8417,
	"./monster.png": 4368,
	"./role": 4444,
	"./role.json": 4444,
	"./role.png": 3412,
	"./terrain": 1918,
	"./terrain.json": 1918,
	"./terrain.png": 2842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9156;